import { CacheTypeEnum } from "../enums/cacheEnum";

const appConfig = {
    /**
     * @type {'localStorage' |'sessionStorage'}
     */
    permissionCacheType: CacheTypeEnum.LOCAL,
};

export default appConfig;